import { render } from "./AppGuestMenu.vue?vue&type=template&id=612bc43f&scoped=true&lang=pug"
import script from "./AppGuestMenu.vue?vue&type=script&lang=js"
export * from "./AppGuestMenu.vue?vue&type=script&lang=js"

import "./AppGuestMenu.vue?vue&type=style&index=0&id=612bc43f&lang=scss&scoped=true"

import exportComponent from "/Users/edsonfer/Documents/dev-projects/node-projects/portal-gignet-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-612bc43f"]])

export default __exports__